export const TRACKING_ENDPOINT_PATH = '/v1/track/events'

export const MAX_BATCH_SIZE = 20

/** How long an event may sit in the buffer before it is sent anyway. */
export const FLUSH_INTERVAL_MS = 10_000

export const MAX_QUEUE_SIZE = 200

export const CLICK_THROTTLE_MS = 250

export const MAX_CLICKS_PER_PAGE_VIEW = 100

export const CLICK_TARGET_SELECTOR =
  'a, button, [role="button"], input[type="submit"], [data-track]'

/** Scroll marks, in percent of page height. Each is recorded at most once per page view. */
export const SCROLL_MILESTONES = [25, 50, 75, 100]

export const MAX_LABEL_LENGTH = 80
